import './initDefaults';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { AntProvider } from 'eehc-library';
import { BrowserRouter } from 'react-router-dom';
import appQueryClient from './appQueryClient';
import ErrorBoundary from './ErrorBoundary';
import Loader from './components/Loader/Loader';
import App from './App';
import './defaults.scss';
import './index.scss';

ReactDOM.render(
  <AntProvider>
    <Suspense fallback={<Loader size="large" />}>
      <BrowserRouter>
        <QueryClientProvider client={appQueryClient}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </QueryClientProvider>
      </BrowserRouter>
    </Suspense>
  </AntProvider>,
  document.getElementById('root'),
);

console.log('----------------------------------------------------------------------v1');
